module.exports = function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 4);
}([function (e, t, r) {
  e.exports = r(2)();
}, function (e, t) {
  e.exports = require("react");
}, function (e, t, r) {
  "use strict";

  var n = r(3);

  function o() {}

  function l() {}

  l.resetWarningCache = o, e.exports = function () {
    function e(e, t, r, o, l, a) {
      if (a !== n) {
        var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw c.name = "Invariant Violation", c;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var r = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      elementType: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t,
      checkPropTypes: l,
      resetWarningCache: o
    };
    return r.PropTypes = r, r;
  };
}, function (e, t, r) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (e, t, r) {
  "use strict";

  r.r(t);
  var n = r(1),
      o = r.n(n),
      l = r(0),
      a = r.n(l);

  function c() {
    return (c = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];

        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function i(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function u(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? i(r, !0).forEach(function (t) {
        p(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(r).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  function p(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  function f(e, t) {
    if (null == e) return {};

    var r,
        n,
        o = function (e, t) {
      if (null == e) return {};
      var r,
          n,
          o = {},
          l = Object.keys(e);

      for (n = 0; n < l.length; n++) {
        r = l[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
      }

      return o;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var l = Object.getOwnPropertySymbols(e);

      for (n = 0; n < l.length; n++) {
        r = l[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
      }
    }

    return o;
  }

  var s = function s(e) {
    var t = e.cellComponent,
        r = e.cells,
        n = e.children,
        l = e.totalColSpan,
        a = void 0 === l ? 4 : l,
        i = e.style,
        p = f(e, ["cellComponent", "cells", "children", "totalColSpan", "style"]),
        s = t;
    return o.a.createElement("div", c({
      style: u({
        display: "grid",
        gridTemplateColumns: "repeat(".concat(a, ", 1fr)")
      }, i),
      className: "crystallize-grid crystallize-grid--css-grid"
    }, p), n ? n({
      cells: r,
      totalColSpan: a
    }) : r.map(function (e, t) {
      return o.a.createElement("div", {
        key: "cell-".concat(t),
        className: "crystallize-grid__cell",
        style: {
          gridColumn: "span ".concat(e.layout.colspan),
          gridRow: "span ".concat(e.layout.rowspan)
        }
      }, o.a.createElement(s, {
        cell: e,
        totalColSpan: a
      }));
    }));
  };

  s.propTypes = {
    cellComponent: a.a.oneOfType([a.a.node, a.a.func]),
    cells: a.a.arrayOf(a.a.object).isRequired,
    children: a.a.func,
    totalColSpan: a.a.number
  };
  var y = s;

  function d() {
    return (d = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];

        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function b(e, t) {
    if (null == e) return {};

    var r,
        n,
        o = function (e, t) {
      if (null == e) return {};
      var r,
          n,
          o = {},
          l = Object.keys(e);

      for (n = 0; n < l.length; n++) {
        r = l[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
      }

      return o;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var l = Object.getOwnPropertySymbols(e);

      for (n = 0; n < l.length; n++) {
        r = l[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
      }
    }

    return o;
  }

  var m = function m(e) {
    var t = e.cellComponent,
        r = e.children,
        n = e.rows,
        l = e.totalColSpan,
        a = void 0 === l ? 4 : l,
        c = b(e, ["cellComponent", "children", "rows", "totalColSpan"]),
        i = t;
    return o.a.createElement("table", d({
      className: "crystallize-grid crystallize-grid--table"
    }, c), o.a.createElement("thead", null, o.a.createElement("tr", null, new Array(a).fill(0).map(function (e, t) {
      return o.a.createElement("th", {
        key: "th-".concat(t)
      });
    }))), o.a.createElement("tbody", null, r ? r({
      rows: n,
      totalColSpan: a
    }) : n.map(function (e, t) {
      return o.a.createElement("tr", {
        key: "row-".concat(t)
      }, e.columns.map(function (e, r) {
        return o.a.createElement("td", {
          key: "cell-".concat(t, "-").concat(r),
          className: "crystallize-grid__cell",
          rowSpan: e.layout.rowspan,
          colSpan: e.layout.colspan
        }, o.a.createElement(i, {
          cell: e,
          totalColSpan: a
        }));
      }));
    })));
  };

  m.propTypes = {
    cellComponent: a.a.oneOfType([a.a.node, a.a.func]),
    children: a.a.func,
    rows: a.a.arrayOf(a.a.object),
    totalColSpan: a.a.number
  };
  var O = m;

  function g() {
    return (g = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];

        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function v(e, t) {
    if (null == e) return {};

    var r,
        n,
        o = function (e, t) {
      if (null == e) return {};
      var r,
          n,
          o = {},
          l = Object.keys(e);

      for (n = 0; n < l.length; n++) {
        r = l[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
      }

      return o;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var l = Object.getOwnPropertySymbols(e);

      for (n = 0; n < l.length; n++) {
        r = l[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
      }
    }

    return o;
  }

  r.d(t, "CSSGrid", function () {
    return y;
  }), r.d(t, "Table", function () {
    return O;
  });

  var h = function h(e) {
    var t = e.cellComponent,
        r = e.children,
        n = e.model,
        l = e.type,
        a = void 0 === l ? "grid" : l,
        c = v(e, ["cellComponent", "children", "model", "type"]);
    if (!t && !r) return console.error("@crystallize/grid-renderer: missing ´cellComponent` or children function"), null;
    var i = n.rows;
    if (!i.length) return null;

    var u = function (e) {
      return {
        totalColSpan: e[0].columns.reduce(function (e, t) {
          return e + t.layout.colspan;
        }, 0)
      };
    }(i).totalColSpan;

    if ("table" === a) return o.a.createElement(O, g({
      cellComponent: t,
      rows: i,
      totalColSpan: u
    }, c), r);
    var p = i.map(function (e) {
      return e.columns;
    }),
        f = [].concat.apply([], p);
    return o.a.createElement(y, g({
      cellComponent: t,
      cells: f,
      totalColSpan: u
    }, c), r);
  };

  h.propTypes = {
    cellComponent: a.a.oneOfType([a.a.node, a.a.func]),
    children: a.a.func,
    model: a.a.oneOfType([a.a.object, a.a.arrayOf(a.a.object)]).isRequired,
    type: a.a.string
  };
  t.default = h;
}]);